import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getSelectedPartyTicket } from "./utils";

const PartySubtotal = props => {
  const [subtotal, setSubtotal] = useState("Loading");
  const calculateSubtotal = () => {
    const plan = getSelectedPartyTicket(props.program, props.selected);
    let total_price = parseInt(plan.ticket_price);
    if (plan.addOn) {
      Object.values(props.program.partyDetails.addOnAmounts).map(item => {
        total_price += parseInt(item.price) * parseInt(item.amount);
      });
    }
    setSubtotal(total_price.toFixed(2))
  };
  useEffect(() => {
    calculateSubtotal();
  }, []);
  return (
    <li
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px 10px",
        borderBottom: "1px solid #dedede",
        fontSize: "14px"
      }}
    >
      <p
        style={{
          marginBottom: 0,
          fontFamily: "Open Sans, sans-serif",
          fontWeight: 500,
          fontSize: "14px"
        }}
      >
        Subtotal
      </p>
      <span style={{ fontWeight: 500 }}>${subtotal}</span>
    </li>
  );
};

PartySubtotal.propTypes = {
  program: PropTypes.shape({
    tickets: PropTypes.array.isRequired
  }).isRequired,
  selected: PropTypes.number.isRequired,
};

export default PartySubtotal;
